import React from 'react';
import PropTypes from 'prop-types';
import RenderComponentProto from '../../render-component-proto';

import HealthSelector from "core/gd-components/health/health-selector";

export default class RAGComponentProto extends RenderComponentProto {

    static propTypes = {
        id: PropTypes.string.isRequired,
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value: PropTypes.any,
        canEdit: PropTypes.bool,

        onChange: PropTypes.func,
    }

    static defaultProps = {
        canEdit: false,
    }

    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value !== this.props.value && this.state.value !== this.props.value) {
            this.setState({
                value: this.props.value,
            })
        }
    }

    render() {
        const classes = Classes('gd-field-rag', this.props.renderMode, {
            'disabled': !this.props.canEdit,
        });

        return (
            <div className={classes}>
                <div className="field-holder">
                    <HealthSelector value={this.state.value} disabled={!this.props.canEdit} onChange={this.props.onChange}/>
                </div>
            </div>
        );
    }
}
